import type { BackgroundType } from '@/types/card-balances.types';
export const MAX_BACKGROUND_BYTES = 2 * 1024 * 1024;

export const BACKGROUND_TYPES: readonly BackgroundType[] = ['image/jpeg', 'image/png', 'image/webp'];

export function isBackgroundType(value: string): value is BackgroundType {
  return (BACKGROUND_TYPES as readonly string[]).includes(value);
}

/** Reads a file as base64 (without the data-URL prefix). */
export function readFileAsBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('read-failed'));
    reader.onload = () => {
      const result = typeof reader.result === 'string' ? reader.result : '';
      const comma = result.indexOf(',');
      if (comma < 0) reject(new Error('read-failed'));
      else resolve(result.slice(comma + 1));
    };
    reader.readAsDataURL(file);
  });
}
